module.exports = __webpack_public_path__ + "static/img/hoverlogo11.ff3b302a.png";